module.exports = __webpack_public_path__ + "log green-7f639fc05104cb514a7f.svg";